import styled from 'styled-components';

export const Container = styled.div`
  .ant-form {
    .ant-form-item,
    .ant-input-affix-wrapper {
      margin-bottom: 1rem;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`;
